// Code generated by rwo-uam-manager v1.0.12

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming

export const DefaultActions = {
    Create: "Create",
    Read: "Read",
    Update: "Update",
    Delete: "Delete",
    Manage: "Manage",
    Member: "Member", // applicable only for group permissions
};
